<template>
	<Accordion type="single" class="w-full" collapsible>
		<AccordionItem
			:key="option.label.toString() || 'default-key'"
			:value="option.label.toString() || 'default-value'"
			class="border-none"
		>
			<AccordionTrigger
				class="px-8 py-[13.5px] data-[state=open]:bg-primary-light-4"
			>
				<PortalHeaderNavMobileOption :option="option" />
				<template #icon>
					<IconMaterialSymbolsLightExpandMore
						class="size-6 shrink-0 text-beige transition-transform duration-200"
					/>
				</template>
			</AccordionTrigger>
			<AccordionContent>
				<PortalHeaderNavMobileOptionLink
					v-for="(subOption, index) in option.subOptions"
					:key="`${subOption.label}-${index}`"
					:option="subOption"
					class="px-16 py-3"
				/>
				<!-- <PortalHeaderNavMobileOptionLink
					:option="seeAllOptions"
					class="px-16 py-[13.5px]"
				/> -->
			</AccordionContent>
		</AccordionItem>
	</Accordion>
</template>

<script setup lang="ts">
import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger
} from '@/components/ui/accordion';

import { type NavDefaultOptionConfig } from '.';

// import PortalHeaderNavMobileOptionSeeAll from './PortalHeaderNavMobileOptionSeeAll.vue';

defineProps<{
	option: NavDefaultOptionConfig;
}>();

// const seeAllOptions = {
// 	label: PortalHeaderNavMobileOptionSeeAll,
// 	route: '/venda/imoveis/sao-paulo-sp-brasil'
// };
</script>
